<div class="order-details-overlay" (click)="close.emit()">
  <div
    class="order-details-panel"
    role="dialog"
    aria-modal="true"
    aria-labelledby="discount-details-title"
    (click)="$event.stopPropagation()"
  >
    <div class="panel-header">
      <div class="header-content">
        <h2 id="discount-details-title" class="panel-title">Discount Details</h2>
        <button type="button" class="close-button" aria-label="Close" (click)="close.emit()">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L11 11M1 11L11 1"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      @if (discount(); as currentDiscount) {
        <div class="order-info">
          <div class="order-id-label">DISCOUNT ID</div>
          <div class="order-id-row">
            <span class="order-id-number">{{ discountId() }}</span>
            <span class="status-badge" [ngClass]="statusBadgeClass()">{{
              headerStatusLabel()
            }}</span>
          </div>
        </div>
      }
    </div>

    @if (discount(); as currentDiscount) {
      <div class="panel-content">
        <app-summary-details
          [title]="'Discount Summary'"
          [header]="summaryHeader()"
          [rows]="summaryRows()"
        />

        @if (renewalRows().length > 0) {
          <app-summary-details [title]="'Renewal Schedule'" [rows]="renewalRows()" />
        }

        <button type="button" class="edit-discount-button" (click)="edit.emit(currentDiscount)">
          Edit Discount
        </button>
      </div>
    }
  </div>
</div>
